import { FC, useState } from 'react';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Alert, Box, FormControlLabel, Modal, Stack, Switch, Typography } from '@mui/material';
import { ModalHeader } from '~/components';
import { switchBlockStyles } from '~/components/DeleteConfirmationModal/styles';
import { modalActionBlockStyles, modalSmallContainerStyle } from '~/components/styles';
import { PublishToAtlanIcon } from '~/icons';
import { useAppDispatch } from '~/redux';
import { closeModalById } from '~/redux/slices/modalSlice';

export interface PublishToAtlanModalProps {
  payload: {
    id: string;
    onSubmit: () => void;
  };
}

const PublishToAtlanModal: FC<PublishToAtlanModalProps> = ({ payload: { id, onSubmit } }) => {
  const dispatch = useAppDispatch();
  const [confirmed, setConfirmed] = useState<boolean>(false);

  const handleClose = () => {
    setConfirmed(false);
    dispatch(closeModalById(id));
  };

  const handleSubmit = () => {
    onSubmit();
    handleClose();
  };

  return (
    <Modal open onClose={handleClose}>
      <Box sx={modalSmallContainerStyle}>
        <ModalHeader onClose={handleClose} title={['Publish this dataset to Atlan']} />
        <Stack pt={1} pb={3} px={3} spacing={2} alignItems="center" sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <Box>
            <PublishToAtlanIcon />
          </Box>
          <Typography>
            Propagation of the dataset to Atlan may take up to five minutes, as metadata is transmitted and processed to
            establish the required catalog connections. Once published, the dataset remains managed within HDP, and
            Atlan reflects a governed reference to the dataset.
          </Typography>
          <Alert severity="important">
            Please note that by publishing this dataset, an asset instance will be created and registered in Atlan for
            governance and discoverability.
          </Alert>
          <FormControlLabel
            labelPlacement="end"
            label={`I confirm I wish to publish this dataset to Atlan.`}
            sx={{ ...switchBlockStyles, width: '100%' }}
            control={
              <Switch
                onClick={(e) => e.stopPropagation()}
                onChange={() => setConfirmed(!confirmed)}
                sx={{ mx: '1rem' }}
              />
            }
          />
        </Stack>
        <Box sx={modalActionBlockStyles}>
          <CustomButton buttonType="borderless" label="Cancel" onClick={handleClose} />
          <CustomButton label="Publish" disabled={!confirmed} onClick={handleSubmit} />
        </Box>
      </Box>
    </Modal>
  );
};

export default PublishToAtlanModal;
